import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function KungPaoCauliflower() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Kung Pao Cauliflower</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>For the Baked Crispy Cauliflower</b>
        <br></br>5 tbsp corn starch or other starch<br></br>6 tbsp bread crumbs
        use gluten-free crumbs to make gf<br></br>5 tbsp or more water<br></br>
        1/2 tsp cayenne use a 1/3 tsp for less heat<br></br>2 tsp soy sauce
        <br></br>
        1/4 tsp salt<br></br>
        1/4 tsp roasted sesame oil<br></br>1 tsp oil<br></br>1 medium head of
        cauliflower chopped into florets<br></br>
        <br></br>
        <b>For the Kung Pao sauce:</b>
        <br></br>1 tsp oil<br></br>8 to 10 dried red chilies chinese red
        chilies, or arbol or cayenne, or use california red for less heat
        <br></br>
        1/2 tsp coarsely crushed sichuan peppercorns or use a mix of coarsely
        crushed black pepper and red pepper flakes<br></br>2 to 3 tbsp chopped
        cashews or peanuts<br></br>4 to 5 cloves of garlic minced<br></br>1 inch
        ginger minced<br></br>2 tbsp scallions chopped<br></br>
        <b>Sauce mix</b>
        <br></br>
        2.5 tbsp low sodium soy sauce/tamari use certified gluten-free sauce to
        make gf<br></br>
        1.5 to 2 tbsp rice vinegar<br></br>1 tsp chinese rice wine optional
        <br></br>1 tbsp sugar<br></br>
        1/4 cup + 2 tbsp water use 1/2 cup for more sauce<br></br>1 tsp
        cornstarch<br></br>
      </Typography>

      <Typography>
        Chop up the cauliflower and keep aside. <br></br>
        Preheat the oven to 425 degrees F / 220ºc. Mix the cornstarch
        breadcrumbs, and the rest of the ingredients to make a batter. <br></br>
        Let the batter sit for 10 seconds to thicken if it isn't thick. The
        cornstarch continues to thicken the batter, so as soon as it is a good
        not too watery consistency, start dipping the cauliflower in the batter,
        tap to drop excess and place on parchment lined baking sheet. <br></br>
        If the batter thickens too much while working, add a tsp or more water
        and mix in and continue.<br></br>
        <br></br>
        Bake for 30 minutes or longer until the florets are cooked through.
        Check with a toothpick/knife<br></br>
        <br></br>
        Meanwhile make the sauce. Heat oil in a skillet over medium high heat.{" "}
        <br></br>
        Add the red chilies and peppercorns and cook until the red chilies are
        fragrant, but not overly brown, or someone starts sneezing. (For more
        heat, break some of the chilies into half and add to the skillet.)
        <br></br>
        <br></br>
        Add the nuts and mix for a few seconds. Add the ginger, garlic, reduce
        heat to medium low and continue to cook until the garlic is golden. 4 to
        5 minutes. Stir occasionally.<br></br>
        Add in the scallions, and 2 to 3 tbsp finely chopped green peppers or
        other veggies if using and mix in. Increase heat to medium. Cook for a
        minute.<br></br>
        Mix the sauce ingredients in a bowl and add to the skillet. Continue to
        cook until the sauce comes to a boil and thickens slightly (~2 mins).{" "}
        <br></br>
        Carefully taste and adjust salt, sweet and spice. If the sauce is not
        hot enough, break a few of the chilies open or add in red pepper flakes
        to taste and mix in.<br></br>
        <br></br>
        Arrange the baked cauliflower in a shallow bowl in one layer. When ready
        to serve, Drizzle the sauce over each floret. Serve.<br></br>
        <br></br>
        To store, store the baked cauliflower and sauce separately. Heat the
        sauce, pour over the florets. To serve with rice/cooked grains, double
        the sauce mix and bring to a boil to thicken, toss in the cauliflower
        and serve immediately over rice.
      </Typography>
    </Card>
  );
}
